// extracted by css-extract-rspack-plugin
export default {"AddSectionButton":"XcIoY"};